/* Registers /sw.js. Uses a network-first strategy (see sw.js) so it's safe
 * to run in all environments, including the dev/preview server. */
export function register() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
